// JavaScript Document


function initMenuModal() {

    const documentBody = document.querySelector('body');

    const modalTriggers = document.querySelectorAll('.open-menu-modal');

    console.log(modalTriggers);

    const pageId = document.querySelector('body').dataset.pageId;

    const modalHtml = document.querySelector('#main-menu-holder').innerHTML;

    let dynamicModal;
    let bsDynamicModal;

    modalTriggers.forEach(function(modalTrigger){


        modalTrigger.addEventListener('click', function(e){
           
            e.preventDefault();
            openModal(modalHtml);
        })
    });

    /*

    modalTrigger.addEventListener('click', function(e){
        
        e.preventDefault();
        openModal(htmlHtml);
    })
        */

    function openModal(html) {
        let     modalHTML = '<div class="modal fade" id="dynamicModal" aria-hidden="true" tabindex="-1">';
                modalHTML += '<div class="modal-dialog  modal-xl">';
                modalHTML += '<div class="modal-content bg-primary text-white">';
                modalHTML += '      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>';
                modalHTML += '      <div class="modal-inner">';
                modalHTML +=  html 
                modalHTML += '      </div>';
                modalHTML += '</div>';
                modalHTML += '</div>';
                modalHTML += '</div>';

        appendHtml(document.body, modalHTML);

        dynamicModal = document.getElementById('dynamicModal');

        bsDynamicModal = new bootstrap.Modal('#dynamicModal', {
            keyboard: false
        });
        
        bsDynamicModal.show();

        dynamicModal.addEventListener('shown.bs.modal', event => {

            init();
            _scrollSmoother.pause();

        });

        dynamicModal.addEventListener('hidden.bs.modal', event => {
            dynamicModal.remove();
            _scrollSmoother.unpause();
        });




    }

    function init() {

            const standortSelects = dynamicModal.querySelectorAll('.standort-select');

            standortSelects.forEach(function(standortSelecter){

                initStadortSelect(standortSelecter);

            });
            
            if (dynamicModal.querySelector('.but-form')) {
                initFormButs(dynamicModal);
            }

            if (dynamicModal.querySelector('.nav-link.stellen-item')) {
                initStellenItems(dynamicModal);
            }

            

            

    }

    function closeModal() {
        if (bsDynamicModal) {
            bsDynamicModal.hide();
        }

    }



    return {
        openModal: openModal,
        hide: closeModal,
    };


}
